import React from 'react'
import RozcestinkPnImage from '../../../assets/images/front/rozcestnik-pn-bg.png'
import { useHistory } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import Reviews from '../../../components/Front/Reviews/Reviews'
import experienceIcon from '../../../assets/images/front/svg/experience.svg'
import individualIcon from '../../../assets/images/front/svg/individual.svg'
import effectiveIcon from '../../../assets/images/front/svg/efective.svg'
import lecturersIcon from '../../../assets/images/front/svg/lectors.svg'

const PnAll: React.FC = () => {
  const history = useHistory()

  return (
    <>
      <div className="relative container mx-auto px-4 mt-[52px] md:mt-0 flex flex-col-reverse md:flex-col bg-[#F5FAFF] md:bg-transparent">
        <img
          src={RozcestinkPnImage}
          alt=""
          className="w-full h-full object-cover hidden md:block"
        />
        <div className="px-4 lg:px-0 grid grid-cols-12 gap-4 my-8 md:my-0 top-0 left-0 text-white text-center md:absolute md:top-[200px] md:left-[50%] md:translate-x-[-50%] w-full max-w-[720px] mx-auto">
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#0183BA] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">5. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg mb-2">
              <span
                onClick={() => history.push(routesURLs.pn5Online)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Online
              </span>
            </div>

            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] rounded-lg">
              <span
                onClick={() => history.push(routesURLs.pn5)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Prezenčně
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#00A0E3] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">7. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg mb-2">
              <span
                onClick={() => history.push(routesURLs.pn7Online)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Online
              </span>
            </div>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] rounded-lg">
              <span
                onClick={() => history.push(routesURLs.pn7)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Prezenčně
              </span>
            </div>
          </div>
          <div className="col-span-12 md:col-span-4 rounded-xl bg-[#A8CD00] p-5 min-h-[200px] flex flex-col">
            <h2 className="text-lg lg:text-3xl text-white">9. třída</h2>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] mt-auto rounded-lg mb-2">
              <span
                onClick={() => history.push(routesURLs.pn9Online)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Online
              </span>
            </div>
            <div className="shadow-[3px_4px_10px_0px_rgba(0,0,0,0.15)] rounded-lg">
              <span
                onClick={() => history.push(routesURLs.pn9)}
                className="cursor-pointer w-full text-center block rounded-lg bg-white text-xl text-black font-myriad font-semibold py-1 hover:shadow-[inset_0_-2px_4px_rgba(0,0,0,0.3)] transition-shadow duration-300"
              >
                Prezenčně
              </span>
            </div>
          </div>
        </div>
        <h1 className="md:absolute md:top-[110px] md:left-[50%] md:translate-x-[-50%] text-center text-[#0183BA] mt-5 -mb-5 md:mt-0 md:mb-0">
          Přijímačky nanečisto
        </h1>
      </div>
      <img src={RozcestinkPnImage} alt="" className="w-full h-full object-cover md:hidden -mt-14" />
      <div className="HP">
        <Reviews />
        <div className="px-4 lg:px-0">
          <div className="container mt-[30px] md:mt-[60px] px-4">
            <div className="max-w-[720px] mx-auto">
              <p className="text-center mb-10">
                Vyzkoušejte si přijímačky dřív, než přijdou naostro! Naše zkoušky nanečisto
                probíhají v reálném testovém prostředí, přesně podle formátu Cermat testů. Žáci si
                vyplní kompletní testy nanečisto s časovým limitem, aby zažili skutečnou atmosféru
                přijímaček. Díky těmto testům nanečisto zjistí, jak jsou na přijímačky připraveni,
                odhalí své slabiny a naučí se pracovat pod tlakem. Tak získají sebevědomí a jistotu,
                která jim pomůže uspět u jednotné přijímací zkoušky. A to vše za nejlepší cenu v
                Praze. Přijímačky nanečisto umíme také online z pohodlí vašeho domova.
              </p>
              <div className="grid grid-cols-12">
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={experienceIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Více než 10 let <br />
                    zkušeností
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={individualIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Individuální <br />
                    přístup
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={effectiveIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Nejefektivnější <br />
                    vyučovací metody
                  </span>
                </div>
                <div className="col-span-6 md:col-span-3 flex flex-col items-center gap-4 text-center mb-4 md:mb-0">
                  <div className="h-12 mb-3">
                    <img src={lecturersIcon} alt="" />
                  </div>
                  <span className="text-[#0183BA] uppercase text-xl md:text-[25px]">
                    Několik desítek <br />
                    zkušených lektorů
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PnAll
